import React, { Component } from "react";
import "../style.scss";
import { connect } from "react-redux";
import { savePermissions, getCompanyPermissions, allCompanies } from "../../../../../store/actions";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { clientPermissionsList } from "../../../../../utils/constants";
import Switch from "../../../../../components/switch";
import groupBy from "lodash/groupBy";
import IconSettingClass from '../../../../../components/settingsIcon';

class ClientsPermissionsView extends Component {

  state = {
    loading: false,
    clientsPermissions: [],
    permissionsView: {},
    changes: []
  };


  async componentDidMount() {
    let companyId = this.props.ClientDataReducer?._id || this.props.UserReducer?.companyDetails?._id;
    //await this.props.getCompanyPermissions(companyId);
    const permissions = [...await this.getCompanyPermissions(companyId)];

    let clientsPermissions = clientPermissionsList.map(el => {
      el.isActive = !!permissions.find(p => p.key === el.key && p.isActive);
      return el;
    });
    let permissionsView = groupBy(clientsPermissions, "group");
    this.setState({
      clientsPermissions,
      permissionsView
    });

  };

  getCompanyPermissions = async (companyId) => {
    await this.props.getCompanyPermissions(companyId);
    return [...(this.props.CLIENT_PERMISSIONS || [])];
  };

  handleChange = (key, val, group, idx) => {

    let list = this.state.permissionsView;
    let elem = list[group][idx];
    elem.isActive = val;

    this.monitorChanges(key);

    this.setState({ permissionsView: list });
  };

  monitorChanges = key => {
    let changes = this.state.changes;
    if (changes.includes(key)) {
      changes.splice(changes.indexOf(key), 1);
    }
    else changes.push(key);
    this.setState({ changes });
  };

  savePermissions = async () => {
    let companyId = this.props.ClientDataReducer?._id;
    let perms = this.state.clientsPermissions.map(p => {
      p.company = companyId;
      p.isActive = !!p.isActive;
      return p;
    });
    await this.props.savePermissions(perms).then(() => this.setState({ changes: [] }));
    await this.props.allCompanies();
  };

  render() {
    const { permissionsView } = this.state;
    let groups = Object.keys(permissionsView);

    return <>
      <div className="df align-items-end justify-content-between flex-row-reverse mt-4 mb-3">
        <button className="btn reportBtn" onClick={this.savePermissions} disabled={!this.state.changes.length} >Save</button>
      </div>
      <div className="reportList">

        {
          permissionsView && (Object.keys(permissionsView).map((group, indx) => {
            return <Accordion key={indx}>
              <AccordionSummary
                expandIcon={<IconSettingClass />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                key={`${group}`}
              >
                <Typography className="reportTitle">{group}</Typography>
              </AccordionSummary>

              <AccordionDetails key={group + indx}>
                <div className="tabPanel df align-items-center justify-content-between">
                  {
                    permissionsView[group].map((el, ix) => (
                      <React.Fragment key={el.key + ix}>
                        <div className="tabList df align-items-center justify-content-between">
                          <div className="tabListTitle">
                            {el.label}
                          </div>
                          <div className="tabSwitch">
                            <Switch
                              value={el.isActive}
                              switchAction={(key, val) => this.handleChange(key, val, group, ix)}
                              name={`${el.key}-${ix}`}
                              id={el.key}
                              key={el.key}
                            />
                          </div>
                        </div>
                        {ix % 2 === 1 && <div className="break"></div>}
                      </React.Fragment>
                    ))
                  } </div>
              </AccordionDetails>
            </Accordion>
          }))}
      </div>
    </>
  }
}
const mapStateToProps = ({ UserReducer, PermissionReducer, ClientDataReducer }) => {
  const { CLIENT_PERMISSIONS } = PermissionReducer;
  return { UserReducer, CLIENT_PERMISSIONS, ClientDataReducer };
};

export default connect(mapStateToProps, {
  savePermissions, getCompanyPermissions, allCompanies
})(ClientsPermissionsView);
